import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AreYouLost from '../../components/sections/AreYouLost'
import './notFound.css'

const NotFound = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 7000);

    return () => clearTimeout(timer);

  }, [navigate]);
  
  return (
    <>
    <AreYouLost />
    </>
  )
}

export default NotFound